import { render, staticRenderFns } from "./EducationFilter.vue?vue&type=template&id=1ba357d0&scoped=true&ref=my-modal"
import script from "./EducationFilter.vue?vue&type=script&lang=js"
export * from "./EducationFilter.vue?vue&type=script&lang=js"
import style0 from "./EducationFilter.vue?vue&type=style&index=0&id=1ba357d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba357d0",
  null
  
)

export default component.exports